import historySchema from './history.schema';
import { historyFriendDuoRecordMessage } from './history.ruleset';
import { createMessage, createMessages, SB } from '@play-co/replicant';

export default createMessages(SB.object({ ...historySchema }))({
  /**
   * Add duo record to friend history
   */
  addFriendDuoRecord: createMessage(
    SB.object(historyFriendDuoRecordMessage),
    (state, args) => {
      state.history.push({ type: 'duoFriend', ...args });
    },
  ),
});
